import { API, API_GET } from "../../../Config";

export const GetHomePagelService = () => {
  return API_GET(API.GetService);
};
